export default __webpack_public_path__ + "static/media/who-we-are-Header-Tablet.fe7458fc.jpg";